var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
import { createDisplayName } from "@domains/utils/displayName";
export var orderbookMapper = function (res) {
    var _a, _b;
    return {
        data: {
            type: res.data.type,
            ord: (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.ord) === null || _b === void 0 ? void 0 : _b.map(function (x) {
                return __assign(__assign({}, x), { displayName: createDisplayName(x), ordTim: moment(x === null || x === void 0 ? void 0 : x.ordTim, "DD/MM/YYYY HH:mm:ss").format("DD-MMM-YY hh:mm:ss A") });
            }),
        },
        status: res.status,
    };
};
